export function backgroundSetter() {
    let backgrounds_by_element = [];
    let images_by_element = [];
    let trigger = 'bgSetter';
    let img_selector = 'picture img.img_in_picture';
    this.init = function() {
        if ('IntersectionObserver' in window) {
            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting === false) return;
                    let element = entry.target;
                    this.addBackgroundElement(element);    
                    this.checkBackgrounds();
                    observer.unobserve(element);
                });
            });
            let elements = document.querySelectorAll('.' + trigger);
            elements.forEach((element) => {
                observer.observe(element);
            });    
        } else {
            document.querySelectorAll('.' + trigger).forEach(element => this.addBackgroundElement(element));
            this.checkBackgrounds();
        }
        this.addAllPicturesElements();
        this.checkPictures();

        $(window).resize(function(){
            this.checkBackgrounds();
            this.checkPictures();
        }.bind(this));
    }
    this.setBackground = function(background, size, position, element) {
        element.style.backgroundImage = 'url(' + background + ')';
        element.style.backgroundSize = size;
        element.style.backgroundPosition = position;
    }
    this.checkBackgrounds = function() {
        let viewport = this.getViewPort();
        backgrounds_by_element.forEach(element_data => {
            let background = '',
            size = '',
            position = '';
            element_data['data'].forEach((background_data, index) => {
                if (index == 0) {
                    background = background_data.background;
                    size = background_data.size;
                    position = background_data.position;
                } else if (viewport.width > element_data['data'][index-1].viewport) {
                    background = background_data.background;
                    size = background_data.size;
                    position = background_data.position;
                }
            });
            if ($('html').hasClass('crop_preview') === false) {
                this.setBackground(background, size, position, element_data['element']);
            }
        });
    }
    this.checkPictures = function() {
        let viewport = this.getViewPort();
        images_by_element.forEach(element_data => {
            let size = '',
            position = '',
            width = '',
            height = '';
            element_data['data'].forEach((image_data, index) => {
                if (index == 0) {
                    size = image_data.size;
                    width = element_data['element'].getAttribute('data-width');
                    height = element_data['element'].getAttribute('data-height');
                    position = image_data.position;
                } else if (viewport.width > image_data.viewport) {
                    size = image_data.size;
                    width = image_data.width;
                    height = image_data.height;
                    position = image_data.position;
                }
            });
            if ($('html').hasClass('crop_preview') === false) {
                element_data['element'].setAttribute('width', width);
                element_data['element'].setAttribute('height', height);
                element_data['element'].style.objectFit = size;
                element_data['element'].style.objectPosition = position;
            }
        });
    }
    this.getViewPort = function() {
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    }

    this.addBackgroundElement = function(element) {
        if (element.getAttribute('data-backgrounds') != null) {
            let actual_data = {
                'element': [],
                'data': []
            };
            let backgrounds = element.getAttribute('data-backgrounds').split(',');
            let sizes = element.getAttribute('data-sizes').split(',');
            let positions = element.getAttribute('data-positions').split(',');
            if (backgrounds.length == 1) {
                this.setBackground(backgrounds[0], sizes[0], positions[0], element);
                element.classList.remove(trigger);
            } else {
                actual_data['element'] = element;
                let viewports = element.getAttribute('data-viewports').split(',');
                viewports.forEach((viewport, index) => {
                    let viewport_data = {
                        'viewport' : viewport,
                        'background': backgrounds[index],
                        'size': sizes[index],
                        'position': positions[index]
                    };
                    actual_data['data'].push(viewport_data);
                });
                backgrounds_by_element.push(actual_data);
            }    
        } else {
            element.classList.remove(trigger);
        }
    }
    this.addAllPicturesElements = function() {
        let images = document.querySelectorAll(img_selector);
        images.forEach((element) => {
            let actual_data = {
                'element': [],
                'data': []
            };
            let picture = element.closest('picture');
            let sources = picture.querySelectorAll('source');
            if (sources.length > 0) {
                actual_data['element'] = element;
                sources.forEach((s) => {
                    let viewport_data = {
                        'viewport': parseInt(s.getAttribute('data-viewport')),
                        'image': s.getAttribute('srcset'),
                        'size': s.style.objectFit,
                        'position': s.getAttribute('position'),
                        'width': s.getAttribute('width'),
                        'height': s.getAttribute('height')
                    };
                    actual_data['data'].push(viewport_data);
                });
                let viewport_data = {
                    'viewport': 0,
                    'image': element.getAttribute('srcset'),
                    'size': element.style.objectFit,
                    'position': element.getAttribute('position')
                };
                actual_data['data'].push(viewport_data);
                actual_data['data'].reverse();
                images_by_element.push(actual_data);
            }
        });
    }
}
